var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Well } from "@brushfire/ui";
import { useResizeDetector } from "react-resize-detector";
var FullWell = function (_a) {
    var children = _a.children, isWidget = _a.isWidget, headerHeight = _a.headerHeight, hasFooter = _a.hasFooter, hideFooter = _a.hideFooter, _b = _a.wellSize, wellSize = _b === void 0 ? "lg" : _b, wellStyle = _a.wellStyle;
    var _c = __read(useState(0), 2), savedMinHeight = _c[0], setSavedMinHeight = _c[1];
    var _d = useResizeDetector(), fullWellHeight = _d.height, fullWellContent = _d.ref;
    useEffect(function () {
        var header = document.getElementById("brushfire-theme-header");
        var footer = document.getElementById("brushfire-footer");
        var themeHeaderHeight = 0;
        var footerHeight = 0;
        if (header) {
            themeHeaderHeight = header.offsetHeight;
        }
        if (footer) {
            footerHeight = footer.offsetHeight;
        }
        var minHeight = window.innerHeight -
            (headerHeight !== null && headerHeight !== void 0 ? headerHeight : 0) -
            94 -
            (hasFooter ? (!hideFooter ? 43 : 0) : 14) -
            themeHeaderHeight -
            footerHeight;
        setSavedMinHeight(minHeight);
    }, [headerHeight, hideFooter, fullWellHeight]);
    return (_jsx("div", __assign({ className: "page-body ".concat(wellSize, " ta-left ").concat(isWidget ? "widget" : "") }, { children: _jsx(Well, __assign({ className: "well-".concat(wellSize, "  ").concat(wellStyle ? "well-".concat(wellStyle) : "") }, { children: _jsx("div", __assign({ style: { minHeight: savedMinHeight } }, { children: _jsx("div", __assign({ ref: fullWellContent }, { children: children })) })) })) })));
};
export default FullWell;
